import {IGenericObject} from '../Types/IGenericObject';

const headers: IGenericObject = {
    'Content-Type': 'application/json'
}

export const setUserTokenHeaders = (token: string) => {
    // Only set token when REACT_APP_X_API_KEY was not set
    if (typeof process.env.REACT_APP_X_API_KEY === 'undefined') {
        headers['Authorization'] = `Bearer ${token}`;
    } else if (typeof process.env.REACT_APP_X_API_KEY !== 'undefined') {
        headers['x-api-key'] = process.env.REACT_APP_X_API_KEY;
    }
}

export const setRequestConfig = (method: string, reqOptions?: IGenericObject): RequestInit => {
    // When REACT_APP_X_API_KEY was set,
    // it mean we will send request without user token (don't include credentials)
    const credentials = typeof process.env.REACT_APP_X_API_KEY ? 'same-origin' : 'include';
    const reqHeaders = {...headers};

    if (typeof reqOptions !== 'undefined' && reqOptions.noAuth === 'true') {
        delete reqHeaders.Authorization;
    }

    const config: RequestInit = {
        method,
        headers: reqHeaders,
        credentials
    };

    if (typeof reqOptions !== 'undefined' && typeof reqOptions.payload !== 'undefined') {
        config.body = reqOptions.payload;
    }

    return config;
}
